(function(){
  const banner = document.getElementById('why-address-banner');
  if(!banner){ return; }

  // Show after DOM is ready so position is correct
  const ready = () => banner.hidden = false;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();

  const btn   = banner.querySelector('.why-abtn');
  const sheet = banner.querySelector('#why-address-sheet');
  const close = banner.querySelector('.why-close');

  // Open / close
  btn?.addEventListener('click', () => sheet.hidden = false);
  close?.addEventListener('click', () => sheet.hidden = true);
  sheet?.addEventListener('click', (e) => { if (e.target === sheet) sheet.hidden = true; });

  // Persist selected address or pincode
  const line = banner.querySelector('[data-line="area"]');
  const PIN_KEY = 'WHY_PIN';

  // If guest previously saved a pin, show it
  try{
    const saved = localStorage.getItem(PIN_KEY);
    if (!Shopify.customer && saved && line) line.textContent = saved;
  }catch(_e){}

  // Click any saved address row
  sheet?.addEventListener('click', (e) => {
    const row = e.target.closest('.why-row');
    if(!row) return;
    const txt = `${row.dataset.city || ''} ${row.dataset.zip || ''}`.trim();
    if (line && txt) line.textContent = txt;
    try{ localStorage.setItem(PIN_KEY, txt); }catch(_e){}
    sheet.hidden = true;
  });

  // Guest pin save
  const pinSave = sheet?.querySelector('.why-pin__save');
  pinSave?.addEventListener('click', () => {
    const input = sheet.querySelector('#why-pin');
    const val = (input?.value || '').trim();
    if(/^\d{6}$/.test(val)){
      line.textContent = val;
      try{ localStorage.setItem(PIN_KEY, val); }catch(_e){}
      sheet.hidden = true;
    } else {
      input?.focus();
    }
  });
})();
